import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

export default function BlogCard({ post }) {
  const isLeader = post.type === 'leader';

  return (
    <Link 
      to={`/blog/${post.id}`}
      className="group flex flex-col h-full bg-[var(--bg-surface)] rounded-3xl border border-[var(--border-subtle)] overflow-hidden hover:shadow-xl transition-all duration-500 hover:-translate-y-1"
    >
      <div className={`relative overflow-hidden bg-slate-100 ${isLeader ? 'aspect-[3/4]' : 'aspect-[16/10]'}`}>
        <img 
          src={post.image} 
          alt={post.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        
        <div className="absolute top-4 left-4">
          <span className={`px-3 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest shadow-lg ${
            isLeader 
              ? 'gfi-gradient-bg text-brand-navy' 
              : 'bg-[var(--bg-surface)] text-[var(--text-main)] border border-[var(--border-subtle)]'
          }`}>
            {post.category}
          </span>
        </div>

        {isLeader && (
          <div className="absolute bottom-4 left-4 right-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
             <div className="bg-white/20 backdrop-blur-md border border-white/30 p-3 rounded-xl">
               <p className="text-white text-xs font-bold leading-tight italic">"{post.quote}"</p>
             </div>
          </div>
        )}
      </div>

      <div className="p-6 md:p-8 flex flex-col flex-1">
        <h3 className="text-xl md:text-2xl font-black text-[var(--text-main)] uppercase italic tracking-tight leading-tight mb-4 group-hover:gfi-gradient-text transition-all">
          {post.title}
        </h3>
        
        <p className="text-[var(--text-secondary)] text-sm leading-relaxed font-medium mb-8 line-clamp-3">
          {post.excerpt}
        </p>

        <div className="mt-auto pt-6 border-t border-[var(--border-subtle)] flex items-center justify-between">
          <div>
            <p className="text-[9px] font-black text-[var(--text-main)] uppercase tracking-[0.2em] mb-1">
              {post.author}
            </p>
            <p className="text-[10px] font-bold text-[var(--text-secondary)]">
              {post.date}
            </p>
          </div>
          <div className="w-10 h-10 rounded-full bg-[var(--bg-base)] flex items-center justify-center text-[var(--text-main)] group-hover:bg-brand-navy group-hover:text-white transition-colors">
            <SafeIcon name="ArrowRight" className="w-4 h-4" />
          </div>
        </div>
      </div>
    </Link>
  );
}